import { useUserProfile, useCompanyProject as useCompanyProjectQuery } from '@/core/api/queries';

export const useCompanyProject = () => {
  // Step 1: Get user profile to extract companyId
  const userProfile = useUserProfile();

  const companyId = userProfile.data?.companyId || null;
  const userId = userProfile.data?.id || null;

  // Step 2: Get company project using companyId (disabled if no companyId)
  const companyProject = useCompanyProjectQuery(companyId || '');

  const projectId = companyProject.data?.id || null;

  return {
    // Raw query objects (for bacconsokward compatibility if needed)
    userProfileQuery: userProfile,
    companyProjectQuery: companyProject,

    // Extracted data
    project: companyProject.data,
    projectId,
    companyId,
    userId,

    // Combined states
    isLoading: userProfile.isLoading || companyProject.isLoading,
    isError: userProfile.isError || companyProject.isError,
    error: userProfile.error || companyProject.error,

    // Individual loading states (useful for granular UI feedback)
    isLoadingProfile: userProfile.isLoading,
    isLoadingProject: companyProject.isLoading,
  };
};